import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "flex flex-col pt-2 pb-6" }
const _hoisted_2 = { class: "pb-8" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-col w-full gap-y-1 pt-8"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "font-semibold items-center" }, "Shipment ID", -1)
const _hoisted_5 = {
  key: 0,
  class: "flex flex-row w-full gap-y-1 gap-x-3"
}
const _hoisted_6 = { class: "font-normal" }
const _hoisted_7 = { class: "grid grid-cols-2 gap-y-8 pt-8" }
const _hoisted_8 = {
  key: 1,
  class: "grid grid-cols-2 mt-6 gap-y-8"
}
const _hoisted_9 = { class: "flex flex-col w-full gap-y-8 pt-8" }
const _hoisted_10 = { class: "flex flex-row" }
const _hoisted_11 = { class: "flex flex-row w-full" }
const _hoisted_12 = { class: "flex flex-row" }
const _hoisted_13 = {
  key: 2,
  class: "flex flex-row"
}
const _hoisted_14 = { class: "flex flex-row space-x-3 mt-2" }
const _hoisted_15 = { class: "py-1 px-1" }
const _hoisted_16 = { class: "pb-1" }
const _hoisted_17 = { align: "center" }
const _hoisted_18 = { class: "py-3 pr-6" }
const _hoisted_19 = { class: "py-2 text-black-lp-300 flex" }
const _hoisted_20 = { class: "rounded px-2 py-2 bg-gray-lp-1000" }
const _hoisted_21 = { class: "text-sm font-semibold text-gray-lp-300 mb-2" }
const _hoisted_22 = { class: "text-xs text-gray-lp-800 mb-2" }
const _hoisted_23 = { class: "w-36" }
const _hoisted_24 = { class: "w-full flex flex-row items-center" }
const _hoisted_25 = { class: "w-36 mr-4" }
const _hoisted_26 = { class: "w-36" }
const _hoisted_27 = { class: "w-full flex flex-row items-center" }
const _hoisted_28 = { class: "w-36 mr-4" }
const _hoisted_29 = { class: "w-36" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_CardAddress = _resolveComponent("CardAddress")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_ChipsV2 = _resolveComponent("ChipsV2")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_button_outline = _resolveComponent("button-outline")!
  const _component_ImagePreview = _resolveComponent("ImagePreview")!
  const _component_SnackbarCopy = _resolveComponent("SnackbarCopy")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_DetailLayout, {
      scrollSidebar: "",
      customClass: "px-0",
      onBack: _ctx.goBack,
      title: _ctx.detailData.shipmentId,
      loading: _ctx.apiDetailData.loading,
      error: !!_ctx.apiDetailData.errorType,
      errorType: _ctx.apiDetailData.errorType,
      onTryAgain: _ctx.fetchDetail
    }, {
      data: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode(_component_Title, {
            label: _ctx.$t('pickupCorporate.detailInfo')
          }, null, 8, ["label"]),
          _createVNode("div", _hoisted_2, [
            (_ctx.detailData.isShipmentDone)
              ? (_openBlock(), _createBlock("div", _hoisted_3, [
                  _hoisted_4,
                  (_ctx.detailData.isShipmentDone)
                    ? (_openBlock(), _createBlock("div", _hoisted_5, [
                        _createVNode("div", _hoisted_6, _toDisplayString(_ctx.detailData.shipmentId), 1),
                        _createVNode(_component_lp_button, {
                          title: "Copy",
                          flat: "",
                          compact: "",
                          customClass: "text-red-lp-100",
                          iconLeft: "copy-clipboard",
                          sizeIcon: "15px",
                          color: "transparent",
                          onClick: _ctx.copyShipmentId
                        }, null, 8, ["onClick"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_7, [
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('pickupCorporate.clientRef'),
                value: _ctx.detailData.clientRef
              }, null, 8, ["label", "value"]),
              (!_ctx.isPcaEmpty)
                ? (_openBlock(), _createBlock(_component_DataWrapper, {
                    key: 0,
                    label: _ctx.$t('pickupCorporate.the3lcPickUp'),
                    value: _ctx.detailData.the3LcPickup
                  }, null, 8, ["label", "value"]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.isPcaEmpty)
              ? (_openBlock(), _createBlock("div", _hoisted_8, [
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('pickupCorporate.the3lcPickUp'),
                    value: _ctx.detailData.the3LcPickup
                  }, null, 8, ["label", "value"]),
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('pickupCorporate.districtCity'),
                    value: _ctx.detailData.origin
                  }, null, 8, ["label", "value"])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.isPcaEmpty)
              ? (_openBlock(), _createBlock(_component_CardAddress, {
                  key: 2,
                  data: _ctx.detailData
                }, null, 8, ["data"]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_9, [
              (_ctx.isPcaEmpty)
                ? (_openBlock(), _createBlock(_component_DataWrapper, {
                    key: 0,
                    label: _ctx.$t('pickupCorporate.addressPickUp'),
                    value: _ctx.detailData.pickupAddress
                  }, null, 8, ["label", "value"]))
                : _createCommentVNode("", true),
              (_ctx.isPcaEmpty)
                ? (_openBlock(), _createBlock(_component_DataWrapper, {
                    key: 1,
                    label: _ctx.$t('pickupCorporate.coordLabelGoogle'),
                    value: _ctx.detailData.geoloc
                  }, null, 8, ["label", "value"]))
                : _createCommentVNode("", true),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('pickupCorporate.courierNote'),
                value: _ctx.detailData.courierNote
              }, null, 8, ["label", "value"]),
              _createVNode("div", _hoisted_10, [
                _createVNode(_component_DataWrapper, {
                  class: "w-1/2",
                  label: _ctx.$t('pickupCorporate.estimateKoli'),
                  value: _ctx.detailData.estimateTotalKoli
                }, null, 8, ["label", "value"]),
                _createVNode(_component_DataWrapper, {
                  class: "w-1/2",
                  label: _ctx.$t('pickupCorporate.estimateTonase'),
                  value: _ctx.detailData.estimateTotalTonase + ' kg'
                }, null, 8, ["label", "value"])
              ]),
              _createVNode("div", _hoisted_11, [
                _createVNode(_component_DataWrapper, {
                  class: "w-1/2",
                  label: _ctx.$t('pickupCorporate.vehicleType'),
                  value: _ctx.detailData.transportType
                }, null, 8, ["label", "value"]),
                _createVNode(_component_DataWrapper, {
                  class: "w-1/2",
                  label: _ctx.$t('pickupCorporate.serviceType'),
                  value: _ctx.detailData.serviceCode
                }, null, 8, ["label", "value"])
              ]),
              _createVNode("div", _hoisted_12, [
                _createVNode(_component_DataWrapper, {
                  class: "w-1/2",
                  label: _ctx.$t('pickupCorporate.datePickUp'),
                  value: _ctx.getFormattedPickupDate(_ctx.detailData.pickupDate)
                }, null, 8, ["label", "value"]),
                _createVNode(_component_DataWrapper, {
                  class: "w-1/2",
                  label: _ctx.$t('pickupCorporate.timePickUp'),
                  value: _ctx.formattedPickupTimeWithTz
                }, null, 8, ["label", "value"])
              ]),
              (_ctx.detailData.isShipmentDone)
                ? (_openBlock(), _createBlock("div", _hoisted_13, [
                    _createVNode(_component_DataWrapper, {
                      class: "w-1/2",
                      label: _ctx.$t('pickupCorporate.actualKoliLabel'),
                      value: _ctx.detailData.actualTotalKoli
                    }, null, 8, ["label", "value"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.detailData.shouldPickupProofImageShown)
                ? (_openBlock(), _createBlock(_component_DataWrapper, {
                    key: 3,
                    label: _ctx.$t('pickupCorporate.proofPhoto'),
                    class: "w-6/12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode("div", _hoisted_14, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.detailData.pickupProof, (photo, index) => {
                          return (_openBlock(), _createBlock("div", {
                            key: photo,
                            style: {"box-shadow":"2px 2px 2px 2px #e0e0e0","border-radius":"5px"}
                          }, [
                            _createVNode("div", _hoisted_15, [
                              photo
                                ? (_openBlock(), _createBlock("img", {
                                    key: 0,
                                    src: photo,
                                    alt: "photo",
                                    class: "rounded object-cover cursor-pointer",
                                    style: {"height":"104px","width":"104px"},
                                    onClick: () => _ctx.onPreview(photo)
                                  }, null, 8, ["src", "onClick"]))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode("div", _hoisted_16, [
                              _createVNode("p", _hoisted_17, _toDisplayString(_ctx.$t("pickupCorporate.photoN", { n: index + 1 })), 1)
                            ])
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  }, 8, ["label"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode(_component_Title, {
            label: _ctx.$t('pickupCorporate.listStt')
          }, null, 8, ["label"]),
          _createVNode("div", _hoisted_18, [
            _createVNode(_component_TableV2, {
              data: _ctx.detailData.listStt,
              columns: _ctx.columns,
              pagination: _ctx.pagination,
              hidePagination: "",
              borderTop: false,
              isEmpty: _ctx.isSttEmpty,
              emptyHeaderMessage: _ctx.$t('pickupCorporate.emptyStt'),
              emptyMessage: _ctx.$t('pickupCorporate.emptySttMessage')
            }, null, 8, ["data", "columns", "pagination", "isEmpty", "emptyHeaderMessage", "emptyMessage"])
          ])
        ])
      ]),
      "sub-data": _withCtx(() => [
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('pickupCorporate.statusRequest')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ChipsV2, {
              title: _ctx.lastStatusTitle,
              label: _ctx.detailData.lastStatusColor,
              boldText: false,
              class: "mt-1"
            }, null, 8, ["title", "label"])
          ]),
          _: 1
        }, 8, ["label"]),
        (!_ctx.detailData.isCancelled)
          ? (_openBlock(), _createBlock(_component_DataWrapper, {
              key: 0,
              label: _ctx.$t('pickupCorporate.vehicleNo'),
              value: _ctx.detailData.getPlatNo
            }, null, 8, ["label", "value"]))
          : _createCommentVNode("", true),
        (_ctx.detailData.shouldCourierDataShown)
          ? (_openBlock(), _createBlock(_component_DataWrapper, {
              key: 1,
              label: _ctx.$t('pickupCorporate.courierName'),
              value: _ctx.detailData.courierName
            }, null, 8, ["label", "value"]))
          : _createCommentVNode("", true),
        (_ctx.detailData.shouldCourierDataShown)
          ? (_openBlock(), _createBlock(_component_DataWrapper, {
              key: 2,
              label: _ctx.$t('pickupCorporate.courierPhone'),
              value: _ctx.detailData.courierPhone
            }, null, 8, ["label", "value"]))
          : _createCommentVNode("", true),
        (_ctx.detailData.isCancelled)
          ? (_openBlock(), _createBlock(_component_DataWrapper, {
              key: 3,
              label: _ctx.$t('pickupCorporate.cancelReason')
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_19, [
                  _createVNode("div", _hoisted_20, _toDisplayString(_ctx.detailData.cancelNote || "-"), 1)
                ])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('pickupCorporate.dateCreated'),
          value: _ctx.detailData.formatCreatedAt,
          caption: _ctx.detailData.createdBy
        }, null, 8, ["label", "value", "caption"]),
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('pickupCorporate.dateUpdated'),
          value: _ctx.detailData.formatUpdatedAt,
          caption: _ctx.detailData.updatedBy
        }, null, 8, ["label", "value", "caption"]),
        (_ctx.detailData.isCancelable && _ctx.isAdminTransport)
          ? (_openBlock(), _createBlock(_component_LpButton, {
              key: 4,
              title: _ctx.$t('pickupCorporate.cancelPickUp'),
              customClass: "w-1/2",
              onClick: _ctx.onButtonCancelPressed,
              outline: "",
              textColor: "red-lp-100"
            }, null, 8, ["title", "onClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["onBack", "title", "loading", "error", "errorType", "onTryAgain"]),
    (_ctx.showModalSuccess)
      ? (_openBlock(), _createBlock(_component_Modal, _mergeProps({ key: 0 }, _ctx.modalMessageEntities, { "custom-width": "430px" }), {
          custom: _withCtx(() => [
            _createVNode("section", null, [
              _createVNode("h5", _hoisted_21, _toDisplayString(_ctx.$t("pickupCorporate.modalCancelSuccessTitle")), 1),
              _createVNode("p", _hoisted_22, _toDisplayString(_ctx.$t("pickupCorporate.modalCancelSuccessMessage", {
              shipmentId: _ctx.detailData.shipmentId
            })), 1)
            ])
          ]),
          "custom-button": _withCtx(() => [
            _createVNode("div", _hoisted_23, [
              _createVNode(_component_lp_button, {
                class: "text-white",
                "is-width-full": "",
                "font-bold": "",
                title: "OK",
                onClick: _ctx.onCloseModalSucces
              }, null, 8, ["onClick"])
            ])
          ]),
          _: 1
        }, 16))
      : _createCommentVNode("", true),
    (_ctx.showModalFailed)
      ? (_openBlock(), _createBlock(_component_Modal, _mergeProps({ key: 1 }, _ctx.modalErrorMessageEntities), {
          "custom-button": _withCtx(() => [
            _createVNode("div", _hoisted_24, [
              _createVNode("div", _hoisted_25, [
                _createVNode(_component_button_outline, {
                  "is-width-full": "",
                  "font-bold": "",
                  title: "Kembali",
                  onClick: _cache[1] || (_cache[1] = 
              () => {
                _ctx.showModalFailed = false;
              }
            )
                })
              ]),
              _createVNode("div", _hoisted_26, [
                _createVNode(_component_lp_button, {
                  class: "text-white",
                  "is-width-full": "",
                  "font-bold": "",
                  title: "Ulangi",
                  onClick: _ctx.onSubmit
                }, null, 8, ["onClick"])
              ])
            ])
          ]),
          _: 1
        }, 16))
      : _createCommentVNode("", true),
    (_ctx.showModalConfirm)
      ? (_openBlock(), _createBlock(_component_Modal, _mergeProps({ key: 2 }, _ctx.modalConfirmEntities), {
          "custom-button": _withCtx(() => [
            _createVNode("div", _hoisted_27, [
              _createVNode("div", _hoisted_28, [
                _createVNode(_component_button_outline, {
                  "is-width-full": "",
                  "font-bold": "",
                  title: "Kembali",
                  onClick: _cache[2] || (_cache[2] = 
              () => {
                _ctx.showModalConfirm = false;
              }
            )
                })
              ]),
              _createVNode("div", _hoisted_29, [
                _createVNode(_component_lp_button, {
                  class: "text-white",
                  "is-width-full": "",
                  "font-bold": "",
                  title: "Ya, batal",
                  onClick: _ctx.onSubmit
                }, null, 8, ["onClick"])
              ])
            ])
          ]),
          _: 1
        }, 16))
      : _createCommentVNode("", true),
    _createVNode(_component_ImagePreview, {
      modelValue: _ctx.photoPreview,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.photoPreview = $event)),
      data: _ctx.photoPreviews,
      image: _ctx.photo,
      isTerm: false
    }, null, 8, ["modelValue", "data", "image"]),
    _createVNode(_component_SnackbarCopy, {
      "model-value": _ctx.info,
      message: _ctx.wordingCopied,
      "onUpdate:modelValue": _ctx.closeInfo
    }, null, 8, ["model-value", "message", "onUpdate:modelValue"])
  ], 64))
}